exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-preview-dialog .el-dialog__body{padding:10px}", ""]);

// exports
